module.exports = __webpack_public_path__ + "svg_80x80/koa.67c5a2.svg";